import { gql } from "@apollo/client";
import { PERSON_FRAGMENT } from "@/fragments";

export const CHANGE_DUE_DATES_MUTATION = gql`
  mutation ChangeDueDates($input: CommerceBulkChangeOrderDueDateInput!) {
    commerceBulkChangeOrderDueDate(input: $input) {
      successfulOrders {
        id
        dueDate
      }
      failedOrders {
        id
        dueDate
      }
      message
      success
    }
  }
`;

export const TERMINATE_PROGRAMS_MUTATION = gql`
  mutation terminatePrograms($input: BackofficeDuesBulkTerminateProgramsInput!) {
    duesBulkTerminatePrograms(input: $input) {
      successfulPersonIds
      failedPersonIds
      message
      success
    }
  }
`;

/** Heavy duesOrders eligibility count — keep off the people list critical path. */
export const ELIGIBLE_FOR_TERMINATION_COUNT_QUERY = gql`
  query eligibleForTerminationCount {
    availableForTerminationsDuesOrders: duesOrders(filters: { availableForTerminations: true }) {
      totalCount
    }
  }
`;

export const PEOPLE_QUERY = gql`
  query allPeopleQuery(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $input: BackofficeCRMPeopleInput
    $includeSuspensions: Boolean!
    $includeTerminations: Boolean!
  ) {
    people(first: $first, last: $last, before: $before, after: $after, input: $input) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        ...PersonFragment
        primarySectionAffiliation {
          id
          section {
            id
            name
          }
        }
        suspensions @include(if: $includeSuspensions) {
          code
          startTime
          endTime
        }
        terminations @include(if: $includeTerminations) {
          code
          startTime
          endTime
        }
        employments {
          id
          isPrimary
          facility {
            id
            name
          }
        }
        latestProgram {
          id
          status
          programType {
            id
            name
          }
          band {
            id
            terminatedReason
            terminatesOn
            classification {
              id
              name
              description
            }
          }
        }
      }
    }
  }
  ${PERSON_FRAGMENT}
`;
